import { ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";
import { formatDate } from "@/lib/format";
import { useTranslation } from "@/hooks/useTranslation";

// ─────────────────────────────────────────────
// SecurityCommentBanner
//
// Green banner shown when a reviewer comment exists.
// Design: §6.2.2 Entity Detail — Security Comment Banner
// ─────────────────────────────────────────────

interface SecurityCommentBannerProps {
  comment: string;
  reviewer?: string;
  reviewedAt?: string;
  className?: string;
}

export function SecurityCommentBanner({
  comment,
  reviewer,
  reviewedAt,
  className,
}: SecurityCommentBannerProps) {
  const { t, language } = useTranslation();
  return (
    <div
      className={cn(
        "flex items-start gap-3 rounded-card px-4 py-3",
        className
      )}
      style={{
        backgroundColor: "var(--success-bg)",
        borderLeft: "3px solid var(--success)",
      }}
    >
      <ShieldCheck
        className="mt-0.5 h-4 w-4 flex-shrink-0"
        style={{ color: "var(--success)" }}
      />
      <div className="flex flex-col gap-1 min-w-0">
        <p className="text-[14px] font-medium" style={{ color: "var(--success)" }}>
          {t("assessment.reviewerComment")}
        </p>
        <p className="text-[14px] text-text-secondary">{comment}</p>
        {(reviewer || reviewedAt) && (
          <p className="text-[12px] text-text-muted">
            {reviewer && <span>{reviewer}</span>}
            {reviewer && reviewedAt && <span> · </span>}
            {reviewedAt && (
              <span>{formatDate(reviewedAt, language)}</span>
            )}
          </p>
        )}
      </div>
    </div>
  );
}
